// 导入各节点相关配置文件
// import developSettings from '../config/develop.config';
// import newtestSettings from '../config/newtest.config';
// import prodSettings from '../config/prod.config';

// 判断是什么环境启动，调用不同的IP
let baseUrl = process.env.VUE_APP_HOST_URL;

// 新增参数 userType 用户类型(必传)
// 用户类型：0【患者】1【医生】2【机构】3【管理员】
export default {
  baseUrl,
};
